export const itemIsObject = (item) => {
    return !!item && typeof item !== 'string';
};
export const itemToValue = (item) => {
    if (!item)
        return '';
    if (!itemIsObject(item)) {
        return item;
    }
    return item.value;
};
export const itemToLabelString = (item) => {
    if (!item)
        return '';
    if (!itemIsObject(item)) {
        return item;
    }
    return item.label ?? item.value;
};
export const itemToIcon = (item) => {
    if (!item || !itemIsObject(item)) {
        return undefined;
    }
    return item.icon;
};
export const isItemDisabled = (item) => {
    return itemIsObject(item) && !!item.disabled;
};
export const itemToDescriptionString = (item) => {
    return itemIsObject(item) ? item.description : undefined;
};
